import { getCookie } from 'cookies-next/client';
import { useEffect, useState } from 'react';
import { type PartnerCountryCode, partnerCountryCodes } from '@sola/schema/dotcom/shared/geo.ts';
import type { GeoApiResponseDto } from '@sola/skippy-search-sdk/lib/schema.ts';
export const geoCookieName = 'ignoreGeoRedirect';
const isPartnerCountryCode = (countryCode: string): countryCode is PartnerCountryCode => partnerCountryCodes.includes(countryCode as PartnerCountryCode);
export const useGeoBanner = () => {
  const [countryCode, setCountryCode] = useState<PartnerCountryCode>();
  useEffect(() => {
    if (getCookie(geoCookieName)) {
      return;
    }
    const controller = new AbortController();
    const loadCountryCode = async () => {
      try {
        const response = await fetch('/api/geo', {
          cache: 'no-store',
          signal: controller.signal
        });
        if (!response.ok) {
          return;
        }
        const geo: GeoApiResponseDto | null = await response.json();
        if (geo?.countryCode && isPartnerCountryCode(geo.countryCode)) {
          setCountryCode(geo.countryCode);
        }
      } catch {
        // Geolocation is optional; render no banner when unavailable.
      }
    };
    void loadCountryCode();
    return () => controller.abort();
  }, []);
  return {
    close: () => setCountryCode(undefined),
    countryCode
  };
};